import guideGen1 from "./guide_gen1";
import guideGen2 from "./guide_gen2";
import guideGen3 from "./guide_gen3";
import guideGen4 from "./guide_gen4";
import guideGen5 from "./guide_gen5";
import guideGen6 from "./guide_gen6";
import guideGen32 from "./guide_gen32";
import guideGen42 from "./guide_gen42";
import guideGen52 from "./guide_gen52";
import guideGen62 from "./guide_gen62";

const guideByGen = {
  1: guideGen1,
  2: guideGen2,
  3: guideGen3,
  4: guideGen4,
  5: guideGen5,
  6: guideGen6,
  32: guideGen32,
  42: guideGen42,
  52: guideGen52,
  62: guideGen62,
};

export default guideByGen;
